import React, { useEffect, useState } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { apiKey } from '../../../Constants/googleConstants'

const mapStyling = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: 43.588600,
  lng: -79.640991
};

const mapOptions = {
  draggable: false,
  gestureHandling: 'none'
}

function Map(props) {

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    map.setCenter(props?.location ? props.location : center);
    map.setZoom(10);
    setMap(map);
  }, [props.location])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, [])

  return isLoaded ? (
    <div id="resultsMap" className='rf_map'>
        <GoogleMap
        center={props?.location ? props.location : center}
        zoom={10}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={mapOptions}
        mapContainerStyle={mapStyling}
      >
        {props?.location && (
          <Marker position={{lat: props?.location.lat, lng:props?.location.lng}}></Marker>
        )}
      </GoogleMap>
    </div>
  ) : <></>
}

export default React.memo(Map)